export default {
  data() {
    return {
      formTransitions: {
        act: true,
        flow: [], // each part has by / uid / com / deta / rep / title
        hist: [], // history of approval, can be a larger array
        level: 1, // level of approval, now refer to flow to get status
        model: "A", // approval model
        ntrans: 0, // number of transitions
        stat: {
          new: false, // user for counters (if new and active etc)
          active: false, // relevant to user access. (not active)
          rest: true, // ability to restore /  lock
          progress: true,
          lock: false, // approval locked or suspended
          stall: false, // stalled process
          defer: false, // approval defered
          hold: false, // put on old missing data
          cancel: false, // canecel approval
          revert: false // decision referted needs more work
        }
      },
      formTransitionsFlow: {
        date: "", // when generated the transition
        title: "", // used for histry/flow reasons
        icon: "", // used for hist / flow reasons
        agree: true, // agree not agreed
        uname: "", // first name and last name
        udid: "", // user id
        uemail: "", // user email
        ucom: "" // approval comment made by user
      }
    };
  }
};
